<template>
    <div>
        <div class="cart-cart-header-block">
            <div class="cart-header-block-title">
                {{translate('Showing Nutrition for')}}: {{cart_items.length}} {{translate('item(s)')}}
            </div>
            <router-link class="fusion-button button-flat fusion-button-default-size button-custom button-1 fusion-button-default-span" :to="{name: 'categories'}">
                <span class="fusion-button-text">
                    {{translate('Add more items')}}
                </span>
            </router-link>
        </div>
        <div class="dodel-cart-grid">
                <table>
                    <tr class="cart-line" v-for="(item, index) in cart_items" :key="item.ID">
                        <td>
                            <label><input type="checkbox" :checked="item.include" @change="include_change($event, index)"> {{translate('Include')}}</label>
                        </td>
                        <td>
                            <img :src="item.thumbnail" :alt="item.post_title">
                        </td>
                        <td>
                            <div class="cart-item-title" v-html="item.post_title"></div>
                            <div>
                                {{total_calories(item)}} {{translate('Cals')}}
                            </div>
                        </td>
                        <td>
                            <button class="button-custom button-ddlc button-flat fusion-button fusion-button-default-size fusion-button-default-span" @click="customize_change(index)">{{translate(item_customized(item)?'Customized':'Customize')}}</button>
                            <div v-if="item.customize==true">
                                <div v-for="(nutrition, i) in item.nutritions" :key="'nutri-'+i">
                                    <label style="margin-top:0">
                                        <input type="checkbox" :checked="nutrition.include" @change="include_nutrition_change($event, index, i)">
                                        <strong style="font-size: 16px;">{{nutrition.title}}</strong>
                                        {{view_calories(nutrition.calories)}} {{translate('Cals')}}
                                    </label>
                                </div>
                            </div>
                        </td>
                        <td>
                            <button class="remove-from-cart-button" @click="remove_from_cart(index)">{{translate('Delete')}}</button>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="text-right">
                <router-link class="fusion-button button-flat fusion-button-default-size button-custom button-1 fusion-button-default-span" :to="{name: 'categories'}">
                    <span class="fusion-button-text">
                        {{translate('Add more items')}}
                    </span>
                </router-link>
                <br>
                <button class="remove-from-cart-button" @click="clear_cart()">{{translate('Delete All')}}</button>
            </div>
    </div>
</template>
<script>
export default {
    name: 'cart',
    methods: {
        translate(string){
            return this.$store.state.language[string]
        },
        total_calories(item){
            let sum = 0;
            item.nutritions.forEach(nutrition=>{
                sum+=parseFloat(nutrition.calories)
            })
            const sum_ = Math.round(sum)
            if(sum_==sum)
                return sum
            return sum.toFixed(2)
        },
        view_calories(cals){
            const cals_ = Math.round(cals)
            if(cals_==cals)
                return cals
            return cals.toFixed(2)
        },
        remove_from_cart(index){
            this.$store.commit('remove_from_cart', index)
        },
        include_change($event, index){
            let cart_itms = []
            this.cart_items.forEach((item,index_)=>{
                if(index==index_)
                    item.include = $event.target.checked
                cart_itms.push(item)
            })
            this.$store.commit('update_cart', cart_itms)
        },
        item_customized(item){
            let result = false
            item.nutritions.forEach(nutrition=>{
                if(nutrition.include==false)
                    result = true
            })
            return result
        },
        customize_change(index){
            let cart_itms = []
            this.cart_items.forEach((item,index_)=>{
                if(index==index_)
                    item.customize = !item.customize
                cart_itms.push(item)
            })
            this.$store.commit('update_cart', cart_itms)
        },
        include_nutrition_change($event, index, nutrition_index){
            let cart_itms = []
            this.cart_items.forEach((item,index_)=>{
                if(index==index_)
                    item.nutritions.forEach((nutrition, nutrition_index_)=>{
                        if(nutrition_index==nutrition_index_)
                            nutrition.include = $event.target.checked
                    })
                cart_itms.push(item)
            })
            this.$store.commit('update_cart', cart_itms)
        },
        clear_cart(){
            this.$store.commit('update_cart', [])
        }
    },
    computed: {
        cart_items(){
            return this.$store.state.cart
        }
    }
}
</script>
<style>
    .dodel-cart-grid table{
        width: 100%;
    }
    .dodel-cart-grid table td{
        vertical-align: top;
    }
    .dodel-cart-grid table tr > td:nth-child(1){
        width: 150px;
    }
    .dodel-cart-grid table tr > td:nth-child(2){
        width: 120px;
    }
    .dodel-cart-grid table tr > td:nth-child(3){
        width: 200px;
    }
    .dodel-cart-grid table tr > td:nth-child(4){
        width: 200px;
    }
    .dodel-cart-grid table tr > td:last-child{
        text-align: right;
    }
    .dodel-cart-grid table tr td{
        border-bottom: 1px solid rgba(0,0,0,.2);
        padding: 20px 0;
    }
    .dodel-cart-grid table td img{
        width: 100px;
    }
    .dodel-cart-grid label{
        font-size: 14px;
        margin-top: 40px;display: block;
    }
    .dodel-cart-grid div{
        font-size: 14px;
        color: rgba(0,0,0,.6);
    }
    .dodel-cart-grid div.cart-item-title{
        font-size: 20px;
        font-weight: bold;
        color: rgba(0,0,0,1);
        margin-top: 15px;
    }
    .dodel-cart-grid button{
        margin-top: 40px;
    }
    .dodel-cart-grid button, .remove-from-cart-button{
        background: transparent;
        border: 0;
        font-size: 14px;
        text-decoration: underline;
        color: #006bae;
        cursor: pointer;
    }
    button.button-custom.button-ddlc{
        background: rgba(0,0,0,.1);
        border-radius: 30px;
        text-decoration: none;
        padding: 5px 15px;
        font-size: 12px;
        border: 1px solid;
    }
    .dodel-cart-button{
        background: #d92128;
        border-color: #d92128;
        color: #fff !important;
        font-size: 20px;
        padding: 15px 50px;
        cursor: pointer;
    }
    .cart-cart-header-block{
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(0,0,0,.2);
        padding: 30px 0;
        justify-content: space-between;
    }
    .text-right{
        text-align: right;
    }
    .dodel-cart-grid{
        margin-bottom: 40px;
    }
    .text-right .remove-from-cart-button{
        margin-top: 20px;
    }
    @media screen and (max-width: 768px){
        .cart-cart-header-block{
            display: block;
        }
        .cart-cart-header-block .cart-header-block-title{
            margin-bottom: 20px;
        }
        .cart-line label, .cart-line div, .cart-line button{
            margin-top: 0 !important;
        }
        .cart-line td{
            vertical-align: middle;
        }
        .cart-line{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        .cart-line td{
            display: block;
        }
        .cart-line td:first-child, .cart-line td:nth-child(2), .cart-line td:nth-child(3){
            flex-basis: 30%;
            padding: 10px;
            border-bottom: 0;
        }
        .cart-line td:nth-child(4){
            flex-basis: 70%;
        }
        .cart-line td:nth-child(5){
            flex-basis: 30%;
        }

    }
</style>